// Moved from templates/components/scripts/tealium-orchestrator.html (Phase 3D webpack extraction)
// All HBS #each loops replaced with window.LG_PAGE_DATA reads.
// Synchronous inline calls (getTealiumUtagVariables, GetSearchResults) moved to global.js onReady().

import {
    initializeUtagDataWithCustomer,
    tealiumGetCartItemsNames,
    breadcrumbToCategories,
    processHomePageUtagData,
    processCartPageUtagData,
    processProductPageUtagData,
    processBrandPageUtagData,
    processCategoryPageUtagData,
    process404PageUtagData,
    processPageTypePageUtagData,
} from './tealium-page-processors';

export function getTealiumUtagVariables() {
    let utag_data = initializeUtagDataWithCustomer();

    const pageType = window.BC_CONTEXT?.pageType || '';
    const breadcrumbCategories = breadcrumbToCategories();
    const queryParams = typeof window.parseQueryString === 'function' ? window.parseQueryString() : {};
    const uniqueId = localStorage.getItem('uniqueId');

    // Replace HBS #each cart.items loops with LG_PAGE_DATA reads.
    // cart.items[].category_names is an array in JSON; the original HBS rendered it via
    // toString() (comma-joined) then parseAndSplit() flattened it — replicate that here.
    const items = window.LG_PAGE_DATA?.cartItems || [];
    const categoryArray = items.flatMap(i =>
        Array.isArray(i.category_names) ? i.category_names : (i.category_names ? [i.category_names] : [])
    ).filter(Boolean);
    const categoryProductArray = (window.LG_PAGE_DATA?.category?.products || []).map(p => p.sku).filter(Boolean);
    const productIdArray = items.filter(i => i.sku).map(i => i.sku);
    const quantityNameArray = items.filter(i => i.quantity !== undefined).map(i => i.quantity);
    const urlArray = items.filter(i => i.image).map(i => i.image.data);
    const priceArray = items.filter(i => i.price).map(i => i.price.value);
    const nameArray = tealiumGetCartItemsNames();

    if (uniqueId != null) {
        utag_data.user_id = uniqueId;
    }

    if (pageType === 'default') {
        utag_data = processHomePageUtagData(utag_data);
        window.basePageViewEvent = { ...utag_data };
    } else if (pageType === 'product') {
        utag_data = processProductPageUtagData(utag_data, breadcrumbCategories);
        window.basePageViewEvent = { ...utag_data };
    } else if (pageType === 'category') {
        utag_data = processCategoryPageUtagData(utag_data, breadcrumbCategories, queryParams, categoryArray, categoryProductArray);
        window.basePageViewEvent = { ...utag_data };
    } else if (pageType === 'search') {
        utag_data = processCategoryPageUtagData(utag_data, breadcrumbCategories, queryParams, categoryArray, categoryProductArray);
        utag_data.page_name = 'search results';
        utag_data.tealium_event = 'search results';
        window.basePageViewEvent = { ...utag_data };
    } else if (pageType === 'brand') {
        // Replace HBS #each brand.products loop with LG_PAGE_DATA
        const brandProductArray = (window.LG_PAGE_DATA?.brand?.products || []).map(p => p.sku).filter(Boolean);
        utag_data = processBrandPageUtagData(utag_data, breadcrumbCategories, brandProductArray);
        window.basePageViewEvent = { ...utag_data };
    } else if (pageType === 'brands') {
        utag_data.tealium_event = "content";
        utag_data.page_name = "Brands";
        window.basePageViewEvent = { ...utag_data };
    } else if (pageType === 'cart') {
        utag_data = processCartPageUtagData(
            utag_data,
            breadcrumbCategories,
            productIdArray,
            quantityNameArray,
            urlArray,
            priceArray,
            nameArray,
            categoryArray
        );
        window.basePageViewEvent = { ...utag_data };
    } else if (pageType === 'page') {
        const pageTitle = window.LG_PAGE_DATA?.page?.title || '';
        utag_data = processPageTypePageUtagData(utag_data, pageTitle, uniqueId);
        window.basePageViewEvent = { ...utag_data };
    } else if (pageType === 'newsletter_subscribe') {
        // no-op
    } else if (pageType === '404') {
        const breadcrumbs = window.LG_PAGE_DATA?.breadcrumbs || [];
        utag_data = process404PageUtagData(utag_data, breadcrumbs, categoryProductArray, uniqueId);
        window.basePageViewEvent = { ...utag_data };
    } else if (pageType === 'account' || pageType.startsWith('account_')
        || pageType === 'editaccount' || pageType === 'shippingaddressform') {
        // BC emits account_orderstatus / account_order / account_addressbook / … for the
        // account sub-pages (see pageClasses in app.js) — the old 'account' equality test
        // matched only the landing page, so every sub-page fell through unnamed.
        // TODO(analytics): all account pages currently collapse to a single 'account'
        // event. Revisit soon — decide whether the sub-pages should be separable in
        // reporting (per-page Name) and which Names the onlineService backend accepts.
        utag_data.page_name = pageType;
        utag_data.tealium_event = 'account';
        window.basePageViewEvent = { ...utag_data };
    } else if (pageType === 'login' || pageType === 'createaccount'
        || pageType === 'createaccount_thanks' || pageType === 'forgotpassword'
        || pageType === 'getnewpassword') {
        // 'register' was never a real BC page_type — the create-account page is
        // 'createaccount', so that branch could never match.
        utag_data.page_name = pageType;
        utag_data.tealium_event = 'content';
        window.basePageViewEvent = { ...utag_data };
    }

    // Fallback: every page_type must yield a named page_view. BC emits ~33 page_type
    // values the branches above don't cover (blog, wishlist, giftcertificates*, …);
    // without this basePageViewEvent stayed undefined and the onlineService POST shipped
    // with no Name at all (JSON.stringify drops undefined keys) → HTTP 400.
    if (!window.basePageViewEvent) {
        utag_data.page_name = utag_data.page_name || pageType;
        utag_data.tealium_event = utag_data.tealium_event || 'content';
        window.basePageViewEvent = { ...utag_data };
    }

    return utag_data;
}
